import { render } from "./EditSelectionParcours.vue?vue&type=template&id=d22a6ed4"
import script from "./EditSelectionParcours.vue?vue&type=script&lang=js"
export * from "./EditSelectionParcours.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Downloads\\nm_sportips-inscriptions-main\\nm_sportips-inscriptions-main\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__